export default __webpack_public_path__ + "static/media/logo-company-15.40bbe46a.png";